jQuery(function ($) {
	var $searchInput = $('#search-all');
	var lastXhr, lastValue;
	var minQLen = 3; // minimum query length before searching
	var $searchPanel = $('.js-search-panel-container');

	// Triggers search on input change
	$searchInput.on('change keyup', function (e) {

		var searchValue = $searchInput.val(); // Fetch value

		// checks if it is less then the minimun length before search
		if (searchValue.length < minQLen) {
			return;
		}

		// Same value as last, do no new search
		if (searchValue === lastValue) {
			return;
		}
		if(lastXhr && lastXhr.readyState < 4) { //if previous request hasn't finished yet, abort that one and only do this new one (to prevent timing issues)
			lastXhr.abort();
		}
		lastXhr = fetchBySearch($searchInput, searchValue);
		lastValue = searchValue;

	});

	function fetchBySearch(input, searchTerm) {
		return jQuery.ajax({
			url: '/?ajax=1&s=' + searchTerm,
			success: function(results) {
				$searchPanel.html(results);
			}
		})
	}

});
